<template>
    <el-dialog
     title="添加产品"
     :visible.sync="dialogVisible"
     width="60%"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
      <el-form  :model="form" label-width="80px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="产品编号" >
              <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="产品规格">
              <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label-width="10px">
              <el-button size="small" type="primary"   icon="el-icon-search" @click="search"></el-button>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
        <el-table
            size="small"
            :data="listData"
            highlight-current-row
            v-loading="loading"
            stripe
            border
            element-loading-text="加载中"
            :header-cell-style="_headerStyle"
            style="width: 100%;"
            @selection-change="handleTblSelectionChange"
            max-height="250px"
            ref="productTbl"
            row-key="_id"
            >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column label="产品编号" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格" width="100"></el-table-column>
          <el-table-column prop="technologyCode" label="工艺路线" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.technologyName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="90"></el-table-column>
          <el-table-column prop="stockNum" label="库存数量" width="100"></el-table-column>
          <el-table-column prop="maxStock" label="最大库存" width="100"></el-table-column>
          <el-table-column prop="minStock" label="最小库存" width="100"></el-table-column>
          <el-table-column prop="safeStock" label="安全库存" width="100"></el-table-column>
          <el-table-column prop="source" label="产品属性" width="100" ></el-table-column>
          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

          <el-table-column prop="creater" label="创建人" width="100"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
          <el-table-column prop="updater" label="更新人" width="100"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>



        </el-table>


        <!-- 分页组件 -->
         <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>

         <div style="height: 50px;line-height: 50px;text-align: center;">
          <el-button type="default" size="small" @click="closeDialog">取消</el-button>
          <el-button type="primary" size="small" style="margin-left: 8px;" @click="confirm">确定</el-button>
        </div>

        <CreateProduct :diaVisible="createProductPanVisible" @save="productSave" v-if="createProductPanVisible" @close="close"></CreateProduct>
    </el-dialog>
</template>
<script>
import Pagination from '@/components/Pagination';
import CreateProduct from '@/components/CreateProduct';
import { productGetList ,productDelete,productBatchDelete} from '@/api/basicData';
import {queryAllCustomSet} from '@/api/business';

export default {
    name:'AddProduct',
    components:{
        Pagination,
        CreateProduct
    },
    props:{
      diaVisible:{type:Boolean,default:false,},
      selectData:{type:Array,default:[]},
    },
    watch:{
      selectData:{
        handler:function(newVal,oldVal){
          if(newVal){
              this.tblSelectionList = JSON.parse(JSON.stringify(newVal));


          }
        },
        deep:true,
        immediate:true
      }
  },
    data(){
        return{
            productName:'',
            listData:[

            ],
            loading:false,
             // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            createProductPanVisible:false,
            dialogVisible:false,
            userData:{},
            tblSelectionList:[],
            setList:[],
            sourceList:[{
              label:'自制',
              value:'0'
            },{
              label:'外购',
              value:'1'
            },{
              label:'委外',
              value:'2'
            }],
            form:{}
        }
    },
    created(){
      var userData = window.localStorage.getItem('userdata')
      if(userData){
        this.userData = JSON.parse(userData)
        this.init();

      }
      this.dialogVisible = this.diaVisible;

    },
    methods:{
      init(){
        queryAllCustomSet(this.userData.factoryId,'product').then(res=>{
          this.setList = [];
          if(res['code'] == 200){
            this.setList = res['data'];
            this.search();
          }
        })
      },
      search() {
        var _this = this
        this.loading = true
        var data = {
          condition: this.form,
          currentPage: this.pageparm.currentPage,
          pageSize: this.pageparm.pageSize,
        };
        data.condition.factoryId = this.userData.factoryId;
        productGetList(data).then(res => {
          if(res.code == 200){
            this.listData = res.data.list;
            this.pageparm.total = res.data.total;
            // for(let i = 0;i<this.tblSelectionList.length;i++){
            //   for(let j = 0;j < this.listData.length;j++){
            //     if(this.listData[j]._id == this.tblSelectionList[i]._id){
            //       this.$nextTick(function(){
            //         _this.$refs['productTbl'].toggleRowSelection(_this.listData[j],true);
            //       })
            //       // break;
            //     }
            //   }
            // }
            this.loading = false
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      },
        /**
       * 监听表格选中项变化事件
       */
      handleTblSelectionChange(val) {
        this.tblSelectionList = val;
      },
      productFormat(val){
        var res = this.sourceList.filter(function(item){
          return item.value == val.source
        })
        if(res && res.length!=0){
          return res[0].label
        }
      },
      confirm(){
        setTimeout(() => {
            this.dialogVisible = false;
            this.$emit('confirm',this.tblSelectionList);
        }, 100);
      },
        closeDialog(){
            setTimeout(() => {
                this.dialogVisible = false;
                this.$emit('close')
            }, 100);
        },
        /**
         * 分页插件事件
         */
        callFather(parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.search()
        },
        createProduct(){
            this.createProductPanVisible = true;
        },
        productSave(val){
            this.createProductPanVisible = false
        },
        close(){
          this.createProductPanVisible = false
        }
    }
}
</script>
<style scoped>
    .tbl-btn{
        width: 100%;
        height: 50px;
        line-height: 50px;

    }
    .tbl-btn .tbl-btn-right{
        text-align: right;
    }
    .tbl-pagination{
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/AddProduct.vue